const Message = ({ showMessage }) => {
  // const showMessage = false;
  return (
    <>
    <div className="row justify-content-md-center">
      <div className="col-lg-5  col-md-6  col-sm-12">
      {JSON.stringify(showMessage)?.includes('unsuccessful') && (

        <div className="text-center mrg-t30">
          <img
            width="32"
            height="32"
            src="https://img.icons8.com/external-those-icons-flat-those-icons/32/external-Delete-interface-those-icons-flat-those-icons.png"
            alt="external-Delete-interface-those-icons-flat-those-icons"
          />
        </div>
      )}
      {JSON.stringify(showMessage)?.includes('Payment confirmed!') && (
        <div className="text-center mrg-t30">
          <img width="38" height="38" src="https://img.icons8.com/color/38/ok--v1.png" alt="ok--v1" />
        </div>
      )}
      {/* used for setting the html coming from the api response. */}
      <div dangerouslySetInnerHTML={{ __html: showMessage }} />
      </div>
      </div>
    </>
  );
};

export default Message;